import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavbarComponent } from './navbar/navbar.component';
import { CreateCandidateComponent } from './candidate/create-candidate/create-candidate.component';
import { MatAutocompleteModule as MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { DropdownToggleDirective } from './directives/dropdown-toggle.directive';
import { RouterModule } from '@angular/router';

@NgModule({ declarations: [SidebarComponent, NavbarComponent, CreateCandidateComponent],
    exports: [SidebarComponent, NavbarComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatTooltipModule,
        RouterModule,
      DropdownToggleDirective] })
export class SideNavbarModule { }

export interface INavbarModule {
  name: string;
  route: string;
  icon: string;
  activeClass: string;
}

export interface INavbarService {
  getNavModules: INavbarModule[];
  addNavModule(navModule: INavbarModule): void;
}
